import React, { useState } from "react";
import gifSucess from "../svg x gifs/Light bulb.gif";
import { UserAuth } from "../authcontext/Authcontext";

function Congrats() {
  const { user } = UserAuth();

  function redir() {
    setTimeout(function () {
      window.location.replace("/");
    }, 10000);
  }
  const [count, setcount] = useState(10);
  React.useEffect(() => {
    count > 0 && setTimeout(() => setcount(count - 1), 1000);
    redir();
  }, [count]);
  return (
    <div>
      <div>
        <div className="w-full h-full fixed inset-0 -z-10 bg-gray-100 md:bg-primary-100" />
        <div className="h-full md:min-h-screen w-full md:w-[95%] lg:w-[90%] 2xl:w-[70%] m-auto z-10 bg-primary-100 flex items-center justify-center">
          <div className="bg-gray-100 text-gray-500 md:rounded-3xl md:shadow-xl w-full overflow-hidden">
            <div className="md:flex w-full">
              <div className="items-center flex justify-center w-full md:w-1/2 bg-white">
                <img
                  className="flex justify-center w-auto max-h-[500px] items-center "
                  src={gifSucess}
                  alt="Congrats"
                />
              </div>
              <div className="w-full md:w-1/2 py-4 px-5 md:px-10">
                <div className="text-center pt-10 mb-10">
                  <h1 className="font-bold main-mini-titles capitalize text-primary-100">
                    you have been succeeded
                  </h1>
                  <p className="pt-4 text-center text-[14px] md:text-[16px]">
                    {" "}
                    Email Address : {user && user.email}
                  </p>
                  <div className=" pt-6  text-gray-800">
                    <p className="text-xl capitalize"></p>
                    <br />
                    <p className="text-[14px] md:text-[16px]">
                      {" "}
                      you will be redirected to home after..
                    </p>
                    <span className="text-[220px] animate-bounce text-primary-100">
                      {count}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Congrats;
